export default __webpack_public_path__ + "static/media/clairefontaine16.fead0599.jpg";